import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from '@datadog/browser-core';
import { AWSService } from 'src/app/shared/services/aws.service';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { Attribute } from 'src/app/shared/models/attributes/attribute';

@Component({
  selector: 'app-custom-document-viewer',
  templateUrl: './custom-document-viewer.component.html',
  styleUrls: ['./custom-document-viewer.component.scss'],
  standalone: false
})
export class CustomDocumentViewerComponent implements OnInit, OnDestroy {
  @Input() documentAttribute: Attribute;
  @Input() entityType: string;
  @Input() entityId: string = '';
  constructor(
    private awsService: AWSService,
    private appConfigService: AppConfigService
  ) {}

  private subscription: Subscription;
  public fileNames: Array<string>;

  ngOnInit(): void {
    this.fileNames = this.documentAttribute.value.split('|').map((e) => e.trim());
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  openCustomDocument(fileName: string) {
    let documentKey = this.getDocumentKey(fileName);

    if (this.isInTeamsMode) {
      this.awsService.getTeamObjectUrl(this.entityId, documentKey).subscribe((result) => {
        if (result) window.open(result.url, '_blank');
      });
    } else {
      this.awsService.getUserObjectUrl(this.entityId, documentKey).subscribe((result) => {
        if (result) window.open(result.url, '_blank');
      });
    }
  }

  private get isInTeamsMode(): boolean {
    return this.entityType == 'Team';
  }

  private getDocumentKey(fileName: string): string {
    let tenantId = this.appConfigService.tenant.id;
    return `${tenantId}/${this.isInTeamsMode ? 'team-documents' : 'person-documents'}/${
      this.entityId
    }/${this.documentAttribute.attributeDefinitionId}/${fileName}`;
  }
}
